<template>

    <Head title="Загрузка DVW" />

    <MainLayout>
        <PageHeader title="Загрузка статистики">
            <p class="page-subtitle">Загрузите DVW файлы для импорта статистики матчей</p>
        </PageHeader>

        <DvwUploader :matches="matches" :teams="teams" />
    </MainLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import MainLayout from '@/components/layout/MainLayout.vue';
import PageHeader from '@/components/layout/PageHeader.vue';
import DvwUploader from '@/components/admin/DvwUploader.vue';

const props = defineProps({
    matches: Array,
    teams: Array,
});
</script>
